import { Typography, Stack, Skeleton, Box } from "@mui/material";
import { useTenantTranslation } from "hooks/formatters";
import { useTenant } from "hooks/settings";
import { useGetDeployedPlanResultsQuery } from "src/store/api/generatedApi";
import { OPERATIONS_FEATURE_FLAG } from "components/crane/featureFlags";
import { useIsBehindFeatureFlag } from "hooks/useFeatureFlag";
import RestaurantIcon from "@mui/icons-material/Restaurant";
import { OverviewCard } from "./OverviewCard";
import { CompactMixDisplay } from "./CompactMixDisplay";

export const CurrentRecipe = () => {
  const { t } = useTenantTranslation();
  const tenant = useTenant();
  const operationsEnabled = useIsBehindFeatureFlag(OPERATIONS_FEATURE_FLAG);

  const { data: planResults, isLoading } = useGetDeployedPlanResultsQuery({
    tenantName: tenant,
    planId: "latest",
    period: 1,
    deploymentTypes: ["standard", "edited_standard"],
  });
  // Shadow query for migration diff coverage (Meticulous). Result unused.
  useGetDeployedPlanResultsQuery({
    tenantName: tenant,
    planId: "latest",
    period: 1,
    deploymentTypes: ["standard", "edited_standard"],
  });

  const periodOneMixes = planResults?.periods["1"]?.mixes ?? [];

  return (
    <OverviewCard
      title={t("currentRecipe")}
      icon={RestaurantIcon}
      buttonText={t("viewOperations")}
      buttonHref={operationsEnabled ? `/${tenant}/crane/supervisor` : undefined}
      delay={0.15}
    >
      {isLoading ? (
        <Skeleton variant="rectangular" height={250} />
      ) : periodOneMixes.length > 0 ? (
        <Box sx={{ px: 2 }}>
          <Stack spacing={1.5}>
            {periodOneMixes.map((result) => (
              <Box key={result.mix.id}>
                <Typography
                  variant="body2"
                  color="primary"
                  sx={{ mb: 0.5, fontWeight: 600, fontSize: 13 }}
                >
                  {result.name}
                </Typography>
                <CompactMixDisplay mix={result.mix} />
              </Box>
            ))}
          </Stack>
        </Box>
      ) : (
        <Box sx={{ px: 2 }}>
          <Typography variant="body1" sx={{ color: "text.secondary" }}>
            {t("noRecipeAvailable")}
          </Typography>
        </Box>
      )}
    </OverviewCard>
  );
};
